 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"6728d85a","2":"commons","3":"7bbc3f60fd6b1913b741cc6e27284d3659528ac0","4":"252f366e","5":"2852872c","6":"81443a674c5641983323d103d74e6ba698d0b058","7":"c83f32d774725fc5f551b3deaf5f70b55f54ba12","11":"component---src-pages-404-js","12":"component---src-pages-index-js","13":"component---src-pages-privacy-js","14":"component---src-pages-r-amira-jade-hodes-js","15":"component---src-pages-r-dieter-j-kalkowski-js","16":"component---src-pages-r-donald-alfred-stephenson-jr-js","17":"component---src-pages-r-edith-baxter-js","18":"component---src-pages-r-gail-ann-turner-js","19":"component---src-pages-r-marie-kl-young-chow-js","20":"component---src-pages-r-sambrajyam-reddy-js","21":"component---src-pages-r-vitor-pedroso-js","22":"component---src-pages-stories-123-template-js","23":"component---src-pages-stories-allison-breyfogle-js","24":"component---src-pages-stories-amira-jade-hodes-js","25":"component---src-pages-stories-andrew-cheng-js","26":"component---src-pages-stories-bancroft-wright-js","27":"component---src-pages-stories-bethel-irene-reisdorph-js","28":"component---src-pages-stories-carly-pauline-bazemore-js","29":"component---src-pages-stories-catherine-yeoh-js","30":"component---src-pages-stories-chan-jin-park-js","31":"component---src-pages-stories-chapin-walker-day-jr-js","32":"component---src-pages-stories-cozma-katalin-js","33":"component---src-pages-stories-david-george-otte-js","34":"component---src-pages-stories-dian-astrid-chevalier-oneal-js","35":"component---src-pages-stories-dieter-j-kalkowski-js","36":"component---src-pages-stories-donald-alfred-stephenson-jr-js","37":"component---src-pages-stories-dorothy-ann-phillips-js","38":"component---src-pages-stories-ed-stillman-js","39":"component---src-pages-stories-edith-baxter-js","40":"component---src-pages-stories-eric-lloyd-jones-js","41":"component---src-pages-stories-example-page-js","42":"component---src-pages-stories-gail-ann-turner-js","43":"component---src-pages-stories-howard-stricker-js","44":"component---src-pages-stories-inez-woodard-rucker-js","45":"component---src-pages-stories-ivy-simpson-js","46":"component---src-pages-stories-jesse-brown-js","47":"component---src-pages-stories-jimmy-gamonet-de-los-heros-js","48":"component---src-pages-stories-joanne-mackey-bell-js","49":"component---src-pages-stories-john-r-bentson-js","50":"component---src-pages-stories-jordan-neustaeter-js","51":"component---src-pages-stories-js","52":"component---src-pages-stories-karuna-bhaduri-js","53":"component---src-pages-stories-liberato-mainella-js","54":"component---src-pages-stories-marie-kl-young-chow-js","55":"component---src-pages-stories-marie-kremer-js","56":"component---src-pages-stories-marlene-frances-leonard-miller-burnham-js","57":"component---src-pages-stories-matthew-sokolowski-js","58":"component---src-pages-stories-michael-anolik-js","59":"component---src-pages-stories-olga-migdalia-martinez-js","60":"component---src-pages-stories-patricia-ann-williamson-js","61":"component---src-pages-stories-roger-gauthier-js","62":"component---src-pages-stories-ronald-suresh-persaud-js","63":"component---src-pages-stories-sambrajyam-reddy-js","64":"component---src-pages-stories-sara-miller-arnon-js","65":"component---src-pages-stories-thomas-lee-morris-js","66":"component---src-pages-stories-ulrika-christina-bore-norrman-js","67":"component---src-pages-stories-vitor-pedroso-js","68":"component---src-pages-stories-william-lees-gold-js","69":"component---src-pages-terms-js"}[chunkId]||chunkId) + "-" + {"0":"eb2ddb7a78e18f163fbd","1":"cbedf654839a5508bc44","2":"3f17b15352b61e271524","3":"2164b7b8e1c2564c116e","4":"9a35ac3c75b475fdcbed","5":"3a58c7a7d9a3cf1931ae","6":"e7d06e39af00c685e720","7":"028e4ef563f0722fbebd","11":"2b2f164a63b5ee16f0e6","12":"a426fb7b0e5e21142959","13":"deee16453a6564f8e259","14":"071233daf9bce11b1581","15":"371889fcc78aadc9b496","16":"728a00591938d0732466","17":"dac8d702a668cc602648","18":"47c97814f3843922d46b","19":"c5a3b35577fa6c2b09d1","20":"f31d2f76067f3a6f5c09","21":"9c1ef0431b9d7a00c34a","22":"772412dbcf2c4887ebf8","23":"d1d91ca648cf4981a384","24":"ac3a181fb4353e402f2a","25":"aa2a55bc23fceb170b72","26":"fef4026d5242d4086030","27":"aea1e448a6a42155145f","28":"3ea069075ba0680d605e","29":"5045d7ea9e622d4ce2b1","30":"987a6665fa51de1902f8","31":"99c33ccf05c14b3c4675","32":"3da9c5dea368052976a9","33":"7066c782e3ac859368c6","34":"ec2b4c3690837175c6de","35":"b5c4e9e85fd57eb5a430","36":"e8cf3f0299f99812dfa8","37":"7084cbc83e50ae3477a2","38":"01e9f2eb8a16ebc91132","39":"6e64672e1b7c50bb7e6f","40":"ed8c6f0d1fe4b375022d","41":"019f052f01eb8eb25fae","42":"d4d02ad91d6261f11061","43":"f64fef073c4cd7179c6f","44":"069f0d99188089876831","45":"7230549748a04604810e","46":"74923d96bdf243976fce","47":"ae79e978911d069a52a4","48":"89907cea8dcb2b0a6023","49":"da1d93cb05dbb4bbe3a8","50":"7603dde8deb1e38f7c4d","51":"b6e6ae4f0293ad7f0bd6","52":"a92d5a8c5fb20aa0cffa","53":"24a11fc3cadcc01a9ba8","54":"b685de3a28dc9998cd57","55":"728a29b5a40b0f34f727","56":"fdb9a5b457417a4c29cc","57":"5d673e296054a9eef484","58":"0da19fcb477055b9ee9b","59":"d7be20d28ff1e8359dcf","60":"e22b0ed1283af4d46edc","61":"623ad5f5781fb45f83a5","62":"26158fc2dc24d9eb59df","63":"222a2b8e7c484fe98044","64":"67647b6d84e212aeb7fa","65":"efcf9c812eab3cba60a3","66":"bf23e6f86aea7f5a6676","67":"b05c548ab4b2de74d7f3","68":"6bf58149ee0e479964e8","69":"88dc560b3caaf4de316c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
